export default "__VITE_ASSET__CXsUnbx4__"